const { links } = document;
for (let i = 0, linksLength = links.length; i < linksLength; i += 1) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
